import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router-dom";

import { AdminCommandPalette, useAdminCommandPalette } from "../_components/admin-command-palette";
import { AdminSidebar } from "../_components/admin-sidebar";
import { AdminTopBar } from "../_components/admin-topbar";

export const AdminLayout = () => {
  const palette = useAdminCommandPalette();
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);

  return (
    <>
      <Helmet>
        <title>Admin — Resume Studio</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="flex min-h-screen bg-background text-foreground">
        <AdminSidebar mobileOpen={mobileNavOpen} onMobileOpenChange={setMobileNavOpen} />

        <div className="flex min-w-0 flex-1 flex-col lg:ml-[248px]">
          <AdminTopBar
            onCommandPaletteOpen={() => palette.setOpen(true)}
            onMobileNavOpen={() => setMobileNavOpen(true)}
          />

          {/* Stripe-style: comfortable but not airy. Max width prevents tables
              from going edge-to-edge on ultra-wide monitors. Mobile gets tighter
              gutters so cards/tables aren't pinched between two thick margins. */}
          <main className="flex-1 px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
            <div className="mx-auto w-full max-w-[1280px]">
              <Outlet />
            </div>
          </main>
        </div>

        <AdminCommandPalette open={palette.open} onOpenChange={palette.setOpen} />
      </div>
    </>
  );
};
